<template>
  <div class="inspection--notfound">
    <vue-headful title="Unable to load Inspection" />

    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <Title :hgTitleName="'Inspection Not Found'" />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <Alert :closable="false" type="warning">
            <p>
              Sorry, we weren't able to find that Inspection.<br/>
              Please check that you are able to access this Inspection and that your URL is correct.
            </p>
            <p>
              Or go to <router-link :to="{ name: 'myInspections' }">My Inspections</router-link>
            </p>
          </Alert>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Alert from '@/components/Shared/Alert.vue';
import Title from '@/components/Shared/Title.vue';

export default {
  components: {
    Alert,
    Title,
  },
};
</script>
